var logger = require('../logger/logger');
var orderNew = new Audio('sounds\\order.new.mp3');
var itemDelete = new Audio('sounds\\item.delete.mp3');
var orderDelete = new Audio('sounds\\order.delete.mp3');
var orderUpdate = new Audio('sounds\\order.update.mp3');
var soundSettingsUtils = require('../domain/settings/soundSettingsUtils');

module.exports.playNewOrderSound = function ()
{
    try 
    {
        if (soundSettingsUtils.getNewOrderSoundVolume() <= 0.0001)
            return;

        orderNew.volume = soundSettingsUtils.getNewOrderSoundVolume() * 1;
        orderNew.play().catch(e => logger.warn(`Error occurred while playing a new order sound: ${e}`, {}, e));
    }
    catch(err) 
    {
        logger.warn(`Error occurred while playing a new order sound: ${err}`, {}, err);
    }
}




